query comarcaSelect($where: ComarcaModelFilterInput) {
    data: comarcas(
        where: $where,
        order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}